import { Box } from '@mantine/core'

export const MARKER_SIZE = 28

export interface FloorPlanMarker {
  key: string | number
  x: number
  y: number
  label: string | number
  active?: boolean
  muted?: boolean
}

export function Marker({
  marker,
  offset = 0,
}: {
  marker: FloorPlanMarker
  offset?: number
}) {
  const color = marker.active
    ? 'var(--mantine-color-red-6)'
    : 'var(--mantine-primary-color-filled)'

  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        border: '2px solid var(--mantine-color-white)',
        background: marker.muted ? 'var(--mantine-color-gray-6)' : color,
        opacity: marker.muted ? 0.7 : 1,
        color: 'var(--mantine-color-white)',
        fontSize: 12,
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'var(--mantine-shadow-sm)',
        // Inside KeepScale, so the gap stays the same on screen at any zoom.
        transform: offset ? `translateX(${offset}px)` : undefined,
      }}
    >
      {marker.label}
    </Box>
  )
}
